// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.djelatniciCard_profileCard__og4Rj {
  width: 100%;
  max-width: 220px;
  padding: 16px;
  border-radius: 8px;
  border: 2px solid #ddd;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  text-align: center;
  height: 380px;
}
.djelatniciCard_profileCard__og4Rj:hover {
  border: 2px solid #5f6d7e;
  transition: border 300ms ease-in-out;
  cursor: pointer;
}
.djelatniciCard_profilePhoto__RyLlN {
  width: auto;
  height: 100%;
  border-radius: 4px;
}
.djelatniciCard_selectedCard__L3wyG {
  border: 2px solid #cb9c2d;
}
.djelatniciCard_profile-details__H4-on {
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
}
.djelatniciCard_row__PHp9D {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.djelatniciCard_secondRow__AOy6H {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.djelatniciCard_cardTitle__e-M9q {
  margin: 0;
  font-family: "Inter";
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4d4d4d;
  width: 35%;
}
.djelatniciCard_contactText__RBQH- {
  font-family: "Inter";
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  color: #4d4d4d;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

@media screen and (max-width: 580px) {
  .djelatniciCard_profileCard__og4Rj {
    max-width: 180px;
  }
  .djelatniciCard_contactText__RBQH- {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 20ch;
    white-space: nowrap;
  }
}

@media screen and (max-width: 500px) {
  .djelatniciCard_profileCard__og4Rj {
    max-width: 145px;
    height: 200px;
  }
  .djelatniciCard_profilePhoto__RyLlN {
    max-height: 115px;
  }
  .djelatniciCard_cardTitle__e-M9q {
    font-size: 18px;
  }
}

@media screen and (max-width: 420px) {
  .djelatniciCard_profileCard__og4Rj {
    max-width: 130px;
    height: 190px;
  }
}

@media screen and (max-width: 395px) {
  .djelatniciCard_profileCard__og4Rj {
    max-width: 120px;
    height: 185px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/IPDTeam/components/djelatniciCard.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;AACF","sourcesContent":[".profileCard {\n  width: 100%;\n  max-width: 220px;\n  padding: 16px;\n  border-radius: 8px;\n  border: 2px solid #ddd;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 8px;\n  text-align: center;\n  height: 380px;\n}\n.profileCard:hover {\n  border: 2px solid #5f6d7e;\n  transition: border 300ms ease-in-out;\n  cursor: pointer;\n}\n.profilePhoto {\n  width: auto;\n  height: 100%;\n  border-radius: 4px;\n}\n.selectedCard {\n  border: 2px solid #cb9c2d;\n}\n.profile-details {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  text-align: center;\n}\n.row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n.secondRow {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n}\n.cardTitle {\n  margin: 0;\n  font-family: \"Inter\";\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4d4d4d;\n  width: 35%;\n}\n.contactText {\n  font-family: \"Inter\";\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  letter-spacing: 0em;\n  text-align: left;\n  color: #4d4d4d;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@media screen and (max-width: 580px) {\n  .profileCard {\n    max-width: 180px;\n  }\n  .contactText {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 20ch;\n    white-space: nowrap;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .profileCard {\n    max-width: 145px;\n    height: 200px;\n  }\n  .profilePhoto {\n    max-height: 115px;\n  }\n  .cardTitle {\n    font-size: 18px;\n  }\n}\n\n@media screen and (max-width: 420px) {\n  .profileCard {\n    max-width: 130px;\n    height: 190px;\n  }\n}\n\n@media screen and (max-width: 395px) {\n  .profileCard {\n    max-width: 120px;\n    height: 185px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profileCard": `djelatniciCard_profileCard__og4Rj`,
	"profilePhoto": `djelatniciCard_profilePhoto__RyLlN`,
	"selectedCard": `djelatniciCard_selectedCard__L3wyG`,
	"profile-details": `djelatniciCard_profile-details__H4-on`,
	"row": `djelatniciCard_row__PHp9D`,
	"secondRow": `djelatniciCard_secondRow__AOy6H`,
	"cardTitle": `djelatniciCard_cardTitle__e-M9q`,
	"contactText": `djelatniciCard_contactText__RBQH-`
};
export default ___CSS_LOADER_EXPORT___;
